import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";
import { match } from "./utils";

function handleRequest(
  state: State,
  constraint: Boundaries["removeConstraint"]["request"],
): State {
  const index = state.findIndex((req) => match(constraint, req.constraint));

  return index !== -1
    ? [
        ...state.slice(0, index),
        { constraint, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { constraint, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  constraint: Boundaries["removeConstraint"]["success"],
): State {
  const index = state.findIndex((req) => match(constraint, req.constraint));

  return index !== -1
    ? [
        ...state.slice(0, index),
        { constraint, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { constraint, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  constraint: Boundaries["removeConstraint"]["failure"],
): State {
  const index = state.findIndex((req) => match(constraint, req.constraint));

  return index !== -1
    ? [
        ...state.slice(0, index),
        { constraint, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { constraint, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeConstraintRequested]: handleRequest,
    [events.removeConstraintSucceeded]: handleSuccess,
    [events.removeConstraintFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
